<template>
    <div class="btn-box">
        <el-button class="btn luyin" @click="wxRecord">微信录音</el-button>
        <Ma2
            v-if="isMa2"
            :visible.sync="isMa2"
            :url.sync="ma2Url"
            :categoryId.sync="categoryId"
            @onMa2="onMa2"
            @onFlash="onFlash"
        />
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import Ma2 from '../../../../../../../../components/VoiceConfig/components/ma2'
    import Config from '../../../../../../../../config/app'
    export default {
        name: "luyin-wx-btn",
        components: {
            Ma2
        },
        props: {
            isShop: {
                type: Boolean,
                default: false
            },
        },
        watch: {
            isMa2(state) {
                if(state){
                    this.setSendKeyBoardToCocos({key: 'isMa2', value: false})
                }else{
                    this.setSendKeyBoardToCocos({key: 'isMa2', value: true})
                }
            },
        },
        data(){
            return {
                isMa2: false,
                ma2Url: '',
                categoryId: ''
            }
        },
        methods: {
            ...mapActions(['setSendKeyBoardToCocos']),
            onFlash () {
                this.$emit('onFlash')
            },
            onMa2 ({url, name}) {
                console.log('扫码回调==>', url, name)

                // 将合成音频上传至音频素材
                // 1.将远端地址转成文件流
                // 2.将文件流上传到腾讯云
                // 3.上传合成音频到素材
                // this.uploadAudio({url, type: 'wx', name})
            },
            wxRecord(){
                // 获取录音页面二维码
                // let arr = window.location.href.split('?')
                let audioName = `weixin_${new Date().getFullYear()}${new Date().getMonth()+1}${new Date().getDate()}${new Date().getMilliseconds()}`
                // this.ma2Url = `${Config.wx_web}?${arr[1]}&audioName=${audioName}`
                this.ma2Url = `${Config.wx_web}?category_id=${this.categoryId}&school_id=${this.$store.state.initConfig.school_id}&audioName=${audioName}`
                this.isMa2 = true
                // TODO 微信录制 每2秒轮询一次录音文件是否存在，
                // 如果存在则使用,超过15分钟还没上传表示上传超时 - 关闭当前二维码页面
                // 否则获取成功，走正常业务
            },
        }
    }
</script>

<style lang="scss" scoped>
.btn-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    /*margin: 40px 0px;*/
    width: 100%;

    height:40px;
    background:rgba(255, 120, 56,1);
    border-radius:4px;
}
.luyin {
    /*background-color: #fed800;*/
    width: 100%;
    background:#e7622e !important;
    border: none;
    outline: none;
    font-size: 18px;
    height: 40px;
    color: white !important;
    border-radius: 20px;

    &:hover,&:active{
        opacity: .8;
    }
}
</style>
